import React, { useContext } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import firebase from "../../firebase";
import { SnackbarAlert } from "../SnackbarAlert";

import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import SendRoundedIcon from "@material-ui/icons/SendRounded";
import InputAdornment from "@material-ui/core/InputAdornment";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({
  input: {
    "& .MuiInputBase-root": {
      color: theme.palette.common.white,
    },
    padding: theme.spacing(1),
  },
  sendbtn: {
    color: theme.palette.common.white,
  },
}));

const ForgotPasswordForm = () => {
  const classes = useStyles();
  const { setSnackbarState } = useContext(SnackbarAlert);

  return (
    <Formik
      initialValues={{
        email: "",
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .required("Please input your email")
          .email("Invalid format"),
      })}
      onSubmit={async (values, actions) => {
        try {
          await firebase.auth().sendPasswordResetEmail(values.email);
          setSnackbarState({
            state: true,
            message: "Email sent! 👍",
            status: "info",
          });
        } catch (error) {
          if (error.code === "auth/user-not-found") {
            setSnackbarState({
              state: true,
              message: "This email is not yet registered. 😟",
              status: "error",
            });
          } else {
            setSnackbarState({
              state: true,
              message: "Something went wrong. 😟",
              status: "error",
            });
          }
        } finally {
          actions.resetForm();
        }
      }}
    >
      {(formik) => (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit();
          }}
          noValidate
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="email"
                name="email"
                placeholder="Email ID"
                margin="dense"
                variant="filled"
                {...formik.getFieldProps("email")}
                error={formik.errors.email && formik.touched.email}
                helperText={
                  formik.errors.email && formik.touched.email
                    ? formik.errors.email
                    : "Email ID"
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip
                        title="Send"
                        enterDelay={300}
                        leaveDelay={200}
                        enterNextDelay={300}
                      >
                        <IconButton
                          disabled={formik.isSubmitting}
                          type="submit"
                        >
                          <SendRoundedIcon className={classes.sendbtn} />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
                className={classes.input}
                disabled={formik.isSubmitting}
                fullWidth
              />
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
};

export default ForgotPasswordForm;
